export default __webpack_public_path__ + "static/media/coronfel0.1a3857cc.jpg";